/*
 * Copyright (c) 2017-present, flop! contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 * https://framagit.org/flopedt/flopedt
 */

import { storeToRefs } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router'

import { useAuthStore } from '@/stores/auth.ts'
import { usePermanentStore } from '@/stores/timetable/permanent.ts'
import { useRoomStore } from '@/stores/timetable/room.ts'
import { useTutorStore } from '@/stores/timetable/tutor.ts'
import { RouteNames, routes } from './routes.ts'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior: () => ({ top: 0 }),
  routes: routes,
})

router.beforeEach(async (to, from, next) => {
  const roomStore = useRoomStore()
  const authStore = useAuthStore()
  const permanentStore = usePermanentStore()
  const tutorStore = useTutorStore()
  const { isModulesFetched } = storeToRefs(permanentStore)
  if (!isModulesFetched.value) await permanentStore.fetchModules()
  if (!tutorStore.isAllTutorsFetched) await tutorStore.fetchTutors()
  if (!roomStore.isRoomFetched) await roomStore.fetchRooms()
  if (!permanentStore.areTimeSettingsFetched) permanentStore.fetchTimeSettings()

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    return next({ name: RouteNames.LOGIN, query: { next: to.fullPath } })
  } else {
    next()
  }
})

export default router
